import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  inputForm: {
    '& .MuiTextField-root': {
      margin: theme.spacing(1),
    },
  },
  large: {
    width: '40%',
  },
  small: {
    width: '10%',
  },
  zipcodeText: {
    paddingRight: theme.spacing(2),
  },
}));

export default useStyles;
